import { AddVehicleTypePanel, EditVehicleTypePanel, VehicleTypesPanel } from "@/components/organisms";

export const VehicleTypes = () => {
  return <VehicleTypesPanel />;
};

const VehicleTypesAdd = () => <AddVehicleTypePanel />;
const VehicleTypesEdit = () => <EditVehicleTypePanel />;

VehicleTypes.Edit = VehicleTypesEdit;
VehicleTypes.Add = VehicleTypesAdd;
